import * as React from 'react'
import Navbar from '../../setup/Navbar'
import { Container, Grid2, Typography, Box } from '@mui/material'
import dayjs from 'dayjs'
import DatePickerSelf from '../../../BuiltInComponent/DatePricker'
import TextFields from '../../../BuiltInComponent/TextField'
import Loading from '../../../BuiltInComponent/Loading'
import AutoComplete from '../../../BuiltInComponent/AutoComplete'
import ButtonNormal from '../../../BuiltInComponent/ButtonNormal'
import StickyHeadTable from '../../../BuiltInComponent/TableWithPagination';
import { useDispatch, useSelector } from 'react-redux'
import { getDepartments, getItemList } from '../../../features/setup/useableSlice'
import { deleteItem } from '../../../features/StockManagement/Purchases/prSlice'
import { createVoucherMaster, getVoucherData, createVoucherDetail, getSingleItem, updateSingleItem } from '../../../features/StockManagement/Purchases/prSlice'
import { useLocation, useNavigate } from 'react-router-dom'
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import HeadingText from '../../../BuiltInComponent/HeadingTest'
import StatusText from '../../../BuiltInComponent/StatusText'
import BasicAlerts from '../../../BuiltInComponent/Alert'

export default function AddPurchaseRequest() {

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const location = useLocation()
    const { isLoading, departments, items } = useSelector((state) => state.ru)
    const { voucherDetails, returnprID, addEDLoading } = useSelector((state) => state.pr)
    const { user } = useSelector(state => state.auth)

    const [RONO, setRONO] = React.useState(0)
    const [showAlert, setShowAlert] = React.useState(false);
    // const [selectedSupplier, setSelectedSupplier] = React.useState(null)

    React.useEffect(() => {
        dispatch(getDepartments())
        dispatch(getItemList())
    }, [dispatch])

    const [prmData, setPrmData] = React.useState({
        entDate: dayjs(new Date()).format('MM-DD-YYYY'),
        prID: location.state?.prID || '',
        userID: user.userID ? user.userID : '0',
        deptID: '',
        remarks: '',
        prStatus: 'Draft'
    })

    const [prdData, setPrdData] = React.useState({
        itemCode: '',
        quantity: '',
        editStatus: false,
    })

    React.useEffect(() => {
        const passedprID = location.state?.prID
        if (passedprID) {
            dispatch(getVoucherData(passedprID))
                .then(res => {
                    if (res.payload) {
                        if (res.payload.pm[0].prStatus === 'Draft') {
                            setPrmData(prev => ({
                                ...prev,
                                prID: res.payload.pm[0].prID,
                                entDate: res.payload.pm[0].entDate,
                                deptID: res.payload.pm[0].dept,
                                remarks: res.payload.pm[0].remarks,
                                prStatus: res.payload.pm[0].prStatus
                            }))
                        } else {
                            setShowAlert(true)
                            setTimeout(() => {
                                navigate('/PurchaseRequest')
                            }, 3000);
                        }
                    } else {
                        setPrmData(prev => ({
                            ...prev,
                            prID: returnprID
                        }))
                    }
                })
        }
    }, [dispatch, location.state?.prID, returnprID, navigate])

    const tableColumns = [
        { fieldName: 'RONO', cName: 'Item Code', textAlign: 'left', width: 80, status: 'en', dType: 'string' },
        { fieldName: 'itemDesc', cName: 'Account Paid To', textAlign: 'left', width: 80, status: 'en', dType: 'string' },
        { fieldName: 'quantity', cName: 'Amount', textAlign: 'right', width: 80, status: 'en', dType: 'number' },
        { fieldName: 'Edit', cName: 'Edit', textAlign: 'right', width: 80, status: 'en', dType: 'string' },
        { fieldName: 'Delete', cName: 'Delete', textAlign: 'right', width: 80, status: 'en', dType: 'string' },
        { fieldName: 'Delete', cName: 'Delete', textAlign: 'right', width: 80, status: 'dis', dType: 'string' },
    ];

    const onChange = (data) => {

        const keys = Object.keys(data)
        if (keys[0] === 'deptID') {
            setPrmData(prevState => ({
                ...prevState,
                deptID: data[keys]
            }))

        }
        else if (keys[0] === 'itemCode') {
            setPrdData(prevState => ({
                ...prevState,
                itemCode: data[keys]
            }))

        }
        else {
            setPrmData(prevData => ({
                ...prevData, [keys]: data[keys]
            }))
            setPrdData(prevData => ({
                ...prevData, [keys]: data[keys]
            }))
        }
    }

    const onMasterSave = async () => {
        console.log('Master Data', prmData)
        if (prmData.prID === '') {
            dispatch(createVoucherMaster(prmData)).then((res) => {
                console.log('Expense Master Added', res.payload)
                setPrmData({
                    ...prmData,
                    prID: res.payload.prID,
                })
            })
        } else {
            dispatch(createVoucherMaster(prmData)).then(() => navigate('/PurchaseRequest'))
        }
    }

    const onDetailSave = async () => {

        if (prdData.editStatus) {
            dispatch(updateSingleItem({
                ...prdData,
                RONO: RONO,
                prID: prmData.prID
            })).then((res) => {
                console.log('Item Updated', res.payload)
                setPrdData({
                    itemCode: '',
                    quantity: '',
                    editStatus: false,
                })
                setRONO(0)
            })
        } else {
            dispatch(createVoucherDetail({
                ...prdData,
                prID: prmData.prID
            }))

        }
    }

    const onEditClick = async (itemCode) => {
        console.log('Edit Clicked', itemCode)
        dispatch(getSingleItem(itemCode))
            .then((res) => {
                if (res.payload) {
                    setPrdData({
                        itemCode: res.payload[0].itemCode,
                        quantity: res.payload[0].quantity,
                        editStatus: true,
                    })
                    setRONO(res.payload[0].RONO)
                    console.log('Item Data Fetched', res.payload, RONO)
                }
            })
        // navigate('/EditPurchase', { state: { RONO: itemCode } })
    }
    const onDeleteClick = async (itemCode) => {
        dispatch(deleteItem({ RONO: itemCode, prID: prmData.prID }))
    }
    return (
        <>
            <Navbar />
            <Container>
                {showAlert && (
                    <BasicAlerts
                        msg="This Purchase Request is not in Draft status and cannot be edited."
                        getCloseCommand={setShowAlert}
                    />
                )}
                <Grid2 container spacing={2} sx={{ marginTop: '20px' }}>
                    <Grid2 size={12} sx={{ marginTop: 3 }} >
                        <HeadingText text={'Purchase Request'} />
                    </Grid2>
                    <Grid2 size={0.5}>
                        <KeyboardBackspaceIcon
                            sx={{
                                fontSize: 30, marginLeft: -1, color: 'white', cursor: 'pointer',
                                backgroundColor: '#1D4988', padding: 1, borderRadius: 50
                            }}
                            onClick={() => { navigate('/PurchaseRequest') }} />
                    </Grid2>
                    <Grid2 size={9.5}></Grid2>
                    <Grid2 size={2}>
                        <StatusText status={prmData.prStatus} />
                    </Grid2>
                    <Grid2 size={12}>
                        <Typography sx={{
                            marginLeft: -1,
                            color: 'grey', fontSize: 18, fontWeight: 'bolder'
                        }}>Master Data</Typography>
                    </Grid2>
                    <Grid2 size={1.75}>
                        <DatePickerSelf name="entDate"
                            value={prmData.entDate}
                            onChange={onChange}
                            sx={{ width: '100%' }}
                        />
                    </Grid2>
                    <Grid2 size={1}>
                        <TextFields
                            label="PR ID"
                            name="prID"
                            value={prmData.prID}
                            onChange={onChange}
                            disStatus={true} />
                    </Grid2>
                    <Grid2 size={2.75}>
                        {isLoading ? <Loading /> :
                            <AutoComplete
                                label='Select Department'
                                listData={departments && departments}
                                value={departments.find((c) => c.deptID === prmData.deptID)}
                                onChange={onChange}
                                disabledValue={prmData.prID ? true : false}
                            />
                        }
                    </Grid2>
                    <Grid2 size={5}>
                        <TextFields
                            label="Remarks"
                            name="remarks"
                            value={prmData.remarks}
                            onChange={onChange}
                            disStatus={false} />
                    </Grid2>
                    <Grid2 size={1.5} >
                        <ButtonNormal onClick={onMasterSave} text={'Save'} />
                    </Grid2>
                    <Box sx={{ display: prmData.prID !== '' ? '' : 'none' }}>
                        <Grid2 container spacing={2} sx={{ marginTop: '20px' }}>

                            <Grid2 size={12} sx={{ marginTop: 3 }} >
                                <Typography sx={{
                                    marginLeft: -1,
                                    color: 'grey', fontSize: 18, fontWeight: 'bolder'
                                }}>Details Data</Typography>
                            </Grid2>
                            <Grid2 size={3.5}>
                                {isLoading ? <Loading /> :
                                    <AutoComplete
                                        label='Select Item'
                                        listData={items && items}
                                        onChange={onChange}
                                        value={items.find((c) => c.itemCode === prdData.itemCode)}
                                        disabledValue={false}
                                    />
                                }
                            </Grid2>
                            <Grid2 size={3.5}>
                                <TextFields
                                    label="Quantity"
                                    name="quantity"
                                    value={prdData.quantity}
                                    onChange={onChange}
                                    disStatus={false} />
                            </Grid2>
                            <Grid2 size={1.5}>
                                <ButtonNormal onClick={onDetailSave} text={'ADD'} />
                            </Grid2>
                            <Grid2 size={12}>
                                {addEDLoading ? <Loading /> : <StickyHeadTable tableColumns={tableColumns} tableData={voucherDetails && voucherDetails}
                                    onEditClick={onEditClick} onDeleteClick={onDeleteClick} />
                                }
                            </Grid2>
                        </Grid2>
                    </Box>
                </Grid2>
            </Container >
        </>
    )
}